import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.css'],
})
export class AttachmentsComponent implements OnInit {
  @Input() formStep: FormGroup;

  skattedeklarationFormControl = new FormControl();
  lakarintygFormControl = new FormControl();
  intygDiakonFormControl = new FormControl();
  ovrigaDokumentFormControl = new FormControl();

  destroyed = new Subject();

  constructor() {}

  ngOnInit(): void {
    this.skattedeklarationFormControl.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((file) => {
        if (!!file) {
          this.getFormArray('Skattedeklaration').push(new FormControl(file));
        }
      });

    this.lakarintygFormControl.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((file) => {
        if (!!file) {
          this.getFormArray('Lakarintyg').push(new FormControl(file));
        }
      });

    this.intygDiakonFormControl.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((file) => {
        if (!!file) {
          this.getFormArray('IntygDiakon').push(new FormControl(file));
        }
      });

    this.ovrigaDokumentFormControl.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe((file) => {
        if (!!file) {
          this.getFormArray('OvrigaDokument').push(new FormControl(file));
        }
      });
  }

  ngOnDestroy() {
    this.destroyed.next();
  }

  getFormArray(name: string) {
    return this.formStep.get(name) as FormArray;
  }

  onRemoveFileClick(arrayName: string, index: number, evt: MouseEvent) {
    this.getFormArray(arrayName).removeAt(index);
    evt.preventDefault();
  }
}
